<template>
  <div id="app">
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
export default {
  name: 'App',
metaInfo: {
    // ここに meta タグの設定を追加する
    meta: [
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1.0',
      },
      // 他のメタ情報も必要に応じて追加できます
    ],
  },
}
</script>

<style>
</style>
